import { Controller } from "@hotwired/stimulus"
import QRCode from "qrcode"

export default class extends Controller {
  static targets = ["canvas"]
  static values = { url: String }

  connect() {
    this.render()
  }

  urlValueChanged() {
    this.render()
  }

  async render() {
    if (!this.urlValue || !this.hasCanvasTarget) return

    try {
      await QRCode.toCanvas(this.canvasTarget, this.urlValue, {
        width: 200,
        margin: 2,
        color: { dark: "#000000", light: "#ffffff" }
      })
    } catch (err) {
      console.error("QR code render error:", err)
    }
  }
}
